import { render } from "./xunjiandetail.vue?vue&type=template&id=48f24738&scoped=true&ts=true"
import script from "./xunjiandetail.vue?vue&type=script&lang=ts"
export * from "./xunjiandetail.vue?vue&type=script&lang=ts"

import "./xunjiandetail.vue?vue&type=style&index=0&id=48f24738&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f24738"]])

export default __exports__